export class RadiologyDataModel {
    DoctorName: string;
    RequestDate: string;
    radiologysSubData: radiologyViewModel[];
}
export class radiologyViewModel {
    HOSPITALNO: string;
    REQNO: string;
    REQ_DETAIL_NO: string;
    RequestTime: string;
    STATUS: string;
    Sponsor: string;
    TestCode: string;
    TestName: string;
    INSTRUCTIONS: string;
    ImageByte: string;
    REPORT_NO: string;
    FILE_NAME: string;
	strRadiologyTestReport : string;
}
    
   



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/radiology/radiologydatamodel.ts